import TourPage from "@/components/TourPage";

export default function Akagera4Day() {
  return (
    <TourPage
      tourId="rwanda/akagera-4-day"
      title="4 Days Akagera National Park Safari"
      duration="4 Days / 3 Nights"
      price="Contact for price"
      image="/akageralionrwanda.jpeg"
      description="Dive into the breathtaking beauty of Akagera National Park on this 4-day safari adventure. Explore the park's diverse landscapes, enjoy game drives, boat rides, and hot air balloon tours, and discover the unique culture of Rwanda."
      itinerary={[
        {
          day: 1,
          title: "Arrive in Kigali City, Transfer to Akagera National Park",
          description: "Begin your safari adventure.",
          activities: [
            "Arrive in Kigali and transfer to Akagera National Park",
            "Spend the evening at your lodge, surrounded by sweeping plains and woodlands"
          ],
          accommodation: "Akagera Lodge",
          meals: "Dinner"
        },
        {
          day: 2,
          title: "Discover Akagera National Park - Morning Game Drives and Boat Ride on Lake Ihema",
          description: "Full day exploring the park's wildlife.",
          activities: [
            "Morning game drive to spot wildlife, including kobs, lions, and elephants",
            "Boat ride on Lake Ihema to learn about the park's aquatic ecosystems"
          ],
          accommodation: "Akagera Lodge",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 3,
          title: "Hot Air Balloon Ride and Visit to Imigongo Art Center",
          description: "Unique perspectives and cultural experiences.",
          activities: [
            "Hot air balloon tour over the park's diverse ecosystems",
            "Visit the Imigongo Art Center to learn about traditional art designs made from cow dung"
          ],
          accommodation: "Akagera Lodge",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 4,
          title: "Last Game Drive and Transfer Back to Kigali City",
          description: "Final wildlife viewing before departure.",
          activities: [
            "Early morning game drive to spot any missed wildlife",
            "Transfer back to Kigali city for your homebound flight or hotel"
          ],
          meals: "Breakfast"
        }
      ]}
      inclusions={[
        "Local transportation",
        "Accommodation",
        "Professional guide",
        "All meals (breakfast, lunch, and dinner)",
        "All park entrance fees and permits",
        "All activities mentioned in the itinerary"
      ]}
      exclusions={[
        "International flights (from/to home)",
        "Personal items (souvenirs, travel insurance, visa fees, etc.)",
        "Tip",
        "Government-imposed increase of taxes and/or park fees",
        "Airport taxes"
      ]}
    />
  );
}
